<mat-toolbar [color]="(DevSite ? 'accent' : 'primary')" class="maintoolbar">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div *ngIf="User" fxLayout="column" fxLayoutAlign="center start">
            <button type="button" mat-icon-button (click)="ToggleNavMenu()">
                <mat-icon aria-label="Toggle Navigation Menu Button">menu</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="AwardInfo">
            <span *ngIf="(!SmallSize || !User)" [innerHTML]="AwardInfo.BannerName | safeHTML">Polk Awards</span>
        </ng-container>
        <div fxHide fxShow.gt-md fxLayout="column" fxLayoutAlign="end start">
            <small>A Polk County Public Schools Project</small>
        </div>
        <div *ngIf="DevSite === true && !SmallSize">DEVELOPMENT SITE</div>
    </div>
    <span class="navspacer"></span>
    <app-user-info *ngIf="User" [user]="User"></app-user-info>
    <button type="button" class="noprint" *ngIf="User" mat-icon-button aria-label="Logout" (click)="ToolbarLogout()" title="Logout">
        <mat-icon>exit_to_app</mat-icon>
    </button>
</mat-toolbar>

<mat-sidenav-container style="height:100%">
    <mat-sidenav class="noprint mat-elevation-z5" *ngIf="User" [mode]="(SmallSize ? 'over' : 'side')" [(opened)]="MenuOpen">
        <app-nav-menu [items]="MenuItems" [user]="User" [logout]="LogoutFn" [about]="AboutFn" (navigate)="Navigate($event)"></app-nav-menu>
    </mat-sidenav>
    <mat-sidenav-content #sidenavcontent>
        <div class="routerwrapper" [class.updatebarheight]="UpdateAvailable === true" [class.devbarheight]="DevSite === true" fxLayout="column" fxLayoutAlign="start stretch">
            <router-outlet class="content"></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
